import React from "react";
import Dashboard from "../../components/dashboard";
import { useKeyboardShortcuts } from "../../hooks/useKeyboardShortcuts";

const Home = () => {
  // Enable keyboard shortcuts
  useKeyboardShortcuts();

  return <Dashboard />;
};

export default Home;
